import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if(request.url === `${environment.api}/auth/local`){
      return next.handle(request)
    }
    const idToken = localStorage.getItem('id_token');
    if (idToken) {
      const clonedReq = request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + idToken),
      });
      return next.handle(clonedReq);
    }
    return next.handle(request);
  }
}
